let Test = require('@/mixins/Forms/2022/NRCA_LTO_02_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            form: new Form({
                construction_inspection: {
                    name: `Construction Inspection (NA7.8.2.1)`,
                    rows: {
                        row_1: {
                            id: `1`,
                            type: `Boolean`,
                            question: `The photo controls are shown on plan documents and are installed.`,
                            code_reference: `NA7.8.2.1`,
                            answer: false
                        },
                    },
                    result: false,
                },
                functional_test: {
                    name: `Functional Testing (NA7.8.4)`,
                    rows: {
                        row_1: {
                            id: `1`,
                            type: `Boolean`,
                            question: `During daytime simulation, all controlled luminaires are turned off.`,
                            code_reference: `NA7.8.2.2(a), Section 130.2(c)1, Section 160.5(c)2A`,
                            answer: false
                        },
                        row_2: {
                            id: `2`,
                            type: `Boolean`,
                            question: `During nighttime simulation, all controlled luminaires are turned on.`,
                            code_reference: `NA7.8.2.2(b)`,
                            answer: false
                        },
                    },
                    result: false,
                },
                comments: '',
                testResult: false,
            })
        }
    },

    // methods: {
    //
    //     initTest() {
    //
    //         // Construction Inspection
    //         this.form.construction_inspection.result = true;
    //         _.each(this.form.construction_inspection.questions, question => {
    //             if (!question.answer) {
    //                 this.form.construction_inspection.result = false;
    //             }
    //         })
    //
    //         // Functional Test
    //         this.form.functional_test.result = true;
    //         _.each(this.form.functional_test.questions, question => {
    //             if (!question.answer) {
    //                 this.form.functional_test.result = false;
    //             }
    //         })
    //
    //         // Test Restult
    //         this.form.testResult = (this.form.construction_inspection.result && this.form.functional_test.result);
    //     },
    // },

}

